import { matchPath } from 'react-router-dom'
import {
  SECURE_COMPLIANCE_ASSESSMENT_PATH,
  SECURE_COMPLIANCE_ASSESSMENTS_PATH,
  SECURE_COMPLIANCE_AUDIT_PATH,
  SECURE_COMPLIANCE_PATH,
} from './constants'

export const isComplianceAuditRoutePath = (pathname) => {
  if (
    matchPath(pathname, { path: SECURE_COMPLIANCE_ASSESSMENTS_PATH }) ||
    matchPath(pathname, { path: SECURE_COMPLIANCE_ASSESSMENT_PATH })
  ) {
    return false
  }

  return (
    matchPath(pathname, { path: SECURE_COMPLIANCE_AUDIT_PATH }) ||
    matchPath(pathname, { path: SECURE_COMPLIANCE_PATH, exact: true })
  )
}
